@for (content of $any(data.contents); track content; let idx = $index) {
  @switch (content['type']) {
    @case ('box') {
      <flex-box
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-box-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-box>
    }
    @case ('text') {
      <flex-text
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-text-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-text>
    }
    @case ('filler') {
      <flex-filler
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-filler-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-filler>
    }
    @case ('image') {
      <flex-image
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-image-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-image>
    }
    @case ('icon') {
      <flex-icon
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-icon-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-icon>
    }
    @case ('spacer') {
      <flex-spacer
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-spacer-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-spacer>
    }
    @case ('button') {
      <flex-button
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-button-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-button>
    }
    @case ('separator') {
      <flex-separator
        [data]="$any(content)"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [layout]="data.layout"
        [index]="idx"
        [class.active]="$any(content).isSelect"
        [attr.data-testid]="'flex-separator-content'"
        (click)="
          $event.stopPropagation();
          flexEditorService.selected$.next($any(content))
        "
      >
      </flex-separator>
    }
    @case (false) {
      <p [attr.data-testid]="'flex-empty-content'"></p>
    }
    @default {
      <p [attr.data-testid]="'flex-default-content'"></p>
    }
  }
}

@if (hasShareAction(data)) {
  <ms-share-preview
    [messageId]="data.action['messageId']"
    [shareCurrentMessage]="data.action['shareCurrentMessage']"
    [package]="flexEditorService.package"
    class="absolute right-0 top-1/2 -translate-y-1/2"
  ></ms-share-preview>
}
